import { OuterContainer } from 'components/global/FlexibleCard.style';
import React, { ReactNode } from 'react';

import {
  IngredientContainer,
  IngredientName,
  IngredientImage,
  IngredientTag,
  IngredientTags,
  IngredientDetails,
  IngredientTitle,
  IngredientIntro,
} from './Ingredient.style';

export interface IngredientProps {
  shortName?: string;
  title: string;
  detailsText?: string;
  iconImage: ReactNode;
  tags?: string[];
  introText?: string;
}

export const Ingredient = ({
  shortName,
  title,
  detailsText,
  iconImage,
  tags = [],
  introText,
}: IngredientProps) => (
  <OuterContainer>
    {introText && <IngredientIntro>{introText}</IngredientIntro>}
    <IngredientContainer>
      <IngredientTitle>
        <IngredientName>
          {shortName && <span>{shortName}</span>}
          <span>{title}</span>
        </IngredientName>
        <IngredientImage>{iconImage}</IngredientImage>
      </IngredientTitle>
      <IngredientDetails>{detailsText}</IngredientDetails>
      <IngredientTags>
        {tags.map((tag, index) => {
          return <IngredientTag key={index}>{tag}</IngredientTag>;
        })}
      </IngredientTags>
    </IngredientContainer>
  </OuterContainer>
);
